import React from 'react';
import { Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import PageTitle from '../../components/Common/PageTitle';
import Loading from '../../components/Common/Loading';
import UserTable from '../../components/Tables/UserTable';
import UserSearchForm from '../../forms/UserSearchForm';
import { submissionError } from '../../actions/formActions';
import { submitUserSearchRequest, clearUserSearchForm } from '../../actions/userActions';
import { isTeamUser } from '../../utils/authUtils';
import browserHistory from '../../history';

class Clients extends React.Component {
  componentDidMount() {
    const { user, initialValues } = this.props;
    if (user && isTeamUser(user.roles)) {
      this.props.search(initialValues);
    }
  }

  goToUserDetail = (user) => {
   browserHistory.push({
     pathname: `/clients/${user.id}`,
     state: { from: 'Clients' }
   });
  };

  render() {
    const { showSubmissionError, initialValues, search, reset, users, user, team } = this.props;
    return (
      <ContentWrapper>
        <Row>
          <Col xs={12}>
            <PageTitle title="Client Search" />
          </Col>
        </Row>
        {user && team && team.profile ? (
          <div className="main-content-container">
            <Row className="mt-2">
              <Col xs={12}>
                <UserSearchForm
                  showSubmissionError={showSubmissionError}
                  onSubmit={search}
                  onReset={reset}
                  initialValues={initialValues}
                  teamProfile={team.profile}
                  currentUser={user}
                />
              </Col>
            </Row>
            {users && (
              <Row className="mt-5">
                <Col xs={12}>
                  <UserTable
                    users={users}
                    search
                    title="Search Results"
                    statusColumn="user_role_status"
                    statusLabel="Client Status"
                    isTeamView={true}
                    onRowClick={(e, rowData) => this.goToUserDetail(rowData)}
                  />
                </Col>
              </Row>
            )}
          </div>
        ) : (
          <Loading />
        )}
      </ContentWrapper>
    );
  }
}

Clients.propTypes = {
  showSubmissionError: PropTypes.func,
  initialValues: PropTypes.instanceOf(Object),
  search: PropTypes.func,
  reset: PropTypes.func,
  users: PropTypes.instanceOf(Array),
  user: PropTypes.instanceOf(Object),
  team: PropTypes.instanceOf(Object),
};
const mapStateToProps = (state) => ({
  initialValues: {
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    user_role_status: ['active', 'invited', 'pending', 'pre-active', 'onboarding'],
    ...state.context.userSearchForm,
  },
  users: state.clients.userSearchResults,
  user: state.auth.user,
  team: state.team,
});
const mapDispatchToProps = (dispatch) => ({
  showSubmissionError: (errors) => dispatch(submissionError(errors)),
  search: (values) => {
    dispatch(submitUserSearchRequest(values));
  },
  reset: () => {
    dispatch(clearUserSearchForm());
    dispatch(submitUserSearchRequest());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Clients);
